<!--
******************************************************************************************************
Program ID:
Author:             Dickion To
Date:               2019-01-21
Purpose:            A module for providing common route
Inputs:
Returns:
Copyright:          All the intellectual rights belong to  Airport Authority Hong Kong
------------------------------------------------------------------------------------------------------
Revision History
------------------------------------------------------------------------------------------------------
Initial Version:    2019-01-21
******************************************************************************************************
-->
<template>
  <div class="container-fluid">
    <div class='row'>
      <div v-if='showSidePanel' class='col-md-2 col-xl-2 col-12 d-none d-sm-none d-md-block pr-0'>
        <button class='button' v-on:click='showSidePanel=false'>  <span class="esri-icon-left"></span> </button>
        <b-nav pills vertical class="">
          <b-nav-item
            v-bind:key="subMenuItem.routeName"
            v-for="subMenuItem in subMenuItems"
            :to="{name: subMenuItem.routeName}"> {{subMenuItem.title}}</b-nav-item>
        </b-nav>
        <p class="mt-5 mb-3 text-muted">&copy; Airport Authority Hong Kong. All Rights Reserved.</p>
      </div>
      <span v-if='showSidePanel==false' style='position:absolute;left:0;z-index:999;'>
        <button class='button' v-on:click='showSidePanel=true'> <span class="esri-icon-right"></span>  </button>
      </span>
      <div :class=' `col-md-${showSidePanel?10:12} col-xl-${showSidePanel?10:12} col-12 pr-0` '>
        <router-view ref="router"></router-view>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'agis-side-menu',
  components: {
  },
  props: {
    subMenuItems: {
      defatul: [],
      type: Array
    }
  },
  created: function () {
  },
  data:function(){
    return {
      showSidePanel: true
    };
  },
  mounted:function() {
  },
  methods:{
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui-components/AGISRouteView.vue